export class Context {
  private map = new Map<string, any>()

  as<T extends Context>(): T {
    return this as unknown as T
  }

  set<T>(key: string, value: T): void {
    this.map.set(key, value)
  }

  get<T>(key: string): T | undefined {
    return this.map.get(key) as T | undefined
  }
}
